import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material'
import { Lock as LockIcon } from '@mui/icons-material'
import { useSelector, useDispatch } from 'react-redux'
import { setUnauthorizedModalOpen, resetUnauthorized } from '../store/slices/unauthorizedSlice'
import { resetUnauthorizedModalFlag } from '../services/http-client'
// import { useLogout } from '../utils/logoutUtils'

const UnauthorizedModal: React.FC = () => {
  const dispatch = useDispatch()
  const { isUnauthorizedModalOpen, message } = useSelector(
    (state: any) => state.unauthorized
  )
//   const performLogout = useLogout()

  const handleLogout = () => {
    // Close modal and reset state
    dispatch(resetUnauthorized())
    resetUnauthorizedModalFlag() // Reset the flag so modal can show again after re-login
    
    // Perform logout
    // performLogout()
  }

  const handleClose = () => {
    dispatch(setUnauthorizedModalOpen(false))
  }

  return (
    <Dialog
      open={isUnauthorizedModalOpen}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
          <LockIcon sx={{ fontSize: 48, color: 'error.main', mr: 1 }} />
        </Box>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Unauthorized Access
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please log in again to continue.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pt: 2, gap: 2 }}>
        <Button
          onClick={handleLogout}
          variant="contained"
          color="primary"
          size="large"
          sx={{ minWidth: 120 }}
        >
          Log In Again
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnauthorizedModal
